// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-about[data-v-a8fcf624] {\n  width: 100vw;\n}\n", ""]);
// Exports
module.exports = exports;
